/* Gray Market Airsoft — theme.js
   Global: sticky header, shop dropdown, cart drawer open/close, search panel */

(function () {
  'use strict';

  // ── Sticky header ──────────────────────────────────────────────
  const header = document.getElementById('site-header');
  if (header) {
    const onScroll = () => {
      if (window.scrollY > 8) {
        header.style.background = 'rgba(10,11,10,0.92)';
        header.style.backdropFilter = 'blur(8px)';
      } else {
        header.style.background = 'var(--black)';
        header.style.backdropFilter = 'none';
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ── Shop dropdown ──────────────────────────────────────────────
  const shopItem = document.querySelector('.nav-item-shop');
  if (shopItem) {
    const trigger = shopItem.querySelector('.nav-trigger');
    const dropdown = shopItem.querySelector('.shop-dropdown');
    let leaveTimer;

    const openDropdown = () => {
      clearTimeout(leaveTimer);
      dropdown.style.display = 'block';
      trigger.setAttribute('aria-expanded', 'true');
    };
    const closeDropdown = () => {
      leaveTimer = setTimeout(() => {
        dropdown.style.display = 'none';
        trigger.setAttribute('aria-expanded', 'false');
      }, 80);
    };

    shopItem.addEventListener('mouseenter', openDropdown);
    shopItem.addEventListener('mouseleave', closeDropdown);
    trigger.addEventListener('focus', openDropdown);
    trigger.addEventListener('click', () => {
      if (dropdown.style.display === 'block') closeDropdown();
      else openDropdown();
    });
    // Close when focus leaves the dropdown entirely
    dropdown.addEventListener('focusout', (e) => {
      if (!shopItem.contains(e.relatedTarget)) closeDropdown();
    });
  }

  // ── Cart drawer ────────────────────────────────────────────────
  const cartDrawer = document.getElementById('cart-drawer');
  const cartBackdrop = document.getElementById('cart-backdrop');
  const cartToggle = document.getElementById('cart-toggle');
  const cartClose = document.getElementById('cart-close');
  const cartContinue = document.getElementById('cart-continue');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.style.transform = 'translateX(0)';
    cartBackdrop.style.opacity = '1';
    cartBackdrop.style.pointerEvents = 'auto';
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    cartClose?.focus();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.style.transform = 'translateX(100%)';
    cartBackdrop.style.opacity = '0';
    cartBackdrop.style.pointerEvents = 'none';
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    cartToggle?.focus();
  }

  cartToggle?.addEventListener('click', openCart);
  cartClose?.addEventListener('click', closeCart);
  cartContinue?.addEventListener('click', closeCart);
  cartBackdrop?.addEventListener('click', closeCart);

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeCart();
      searchPanel && closeSearch();
    }
  });

  // Close the cart after successful add-to-cart opens drawer
  document.addEventListener('cart:open', openCart);

  // ── Search panel ───────────────────────────────────────────────
  const searchToggle = document.getElementById('search-toggle');
  const searchPanel = document.getElementById('search-panel');
  const searchClose = document.getElementById('search-close');
  const searchInput = document.getElementById('search-input');

  function openSearch() {
    if (!searchPanel) return;
    searchPanel.style.display = 'block';
    searchToggle?.setAttribute('aria-expanded', 'true');
    searchInput?.focus();
  }

  function closeSearch() {
    if (!searchPanel) return;
    searchPanel.style.display = 'none';
    searchToggle?.setAttribute('aria-expanded', 'false');
    searchToggle?.focus();
  }

  searchToggle?.addEventListener('click', () => {
    if (searchPanel.style.display === 'block') closeSearch();
    else openSearch();
  });
  searchClose?.addEventListener('click', closeSearch);

  // Cmd/Ctrl+K shortcut
  document.addEventListener('keydown', (e) => {
    if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
      e.preventDefault();
      if (searchPanel?.style.display === 'block') closeSearch();
      else openSearch();
    }
  });

  // ── Cart count update ─────────────────────────────────────────
  document.addEventListener('cart:updated', (e) => {
    const countEl = document.getElementById('cart-count');
    if (countEl && e.detail?.item_count !== undefined) {
      countEl.textContent = e.detail.item_count;
    }
  });

  // ── Scroll-reveal ──────────────────────────────────────────────
  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));
  } else {
    // Fallback: just show everything
    document.querySelectorAll('.reveal').forEach(el => el.classList.add('is-visible'));
  }

})();
